<template>
  <div class="content" v-if="!toDetail">
    <PageTabs :open="open" @change="changeRoute"></PageTabs>
    <div class="tool_top">
      <SearchInput ref="searchKey" @setParam="setParam"></SearchInput>
    </div>
    <div class="content_body" ref="scroll_content" @scroll="handleScroll">
      <div class="filter_warp">
        <SearchFilter ref="search_filter" :isFold="toolFold" :searchType="searchType" @setFilter="setParam"
          @changeFold="changeFold"></SearchFilter>
        <div class="tool_fold">
          <div class="fold_panel" @click="changeFold">
            <span>
              <i class="el-icon-arrow-down" v-if="toolFold"></i>
              <i class="el-icon-arrow-up" v-else></i>
              {{ toolFold ? '展开筛选' : '收起筛选' }}
            </span>
          </div>
        </div>
      </div>
      <div class="list_content">
        <div class="list_tool">
          <div class="tool_text">为您找到&nbsp;<span>{{ totalNumber }}</span>&nbsp;条相关结果</div>
          <div class="tool_bar">
            <el-button class="def_btn" plain size="small">
              <span class="btn_txt">按建档时间</span>
              <span class="btn_icon">
                <i class="el-icon-caret-top" :class="sortUp ? 'active' : ''" @click="sortUp = true; getSearch()"></i>
                <i class="el-icon-caret-bottom" :class="sortUp ? '' : 'active'" @click="sortUp = false; getSearch()"></i>
              </span>
            </el-button>
            <!-- <el-button class="def_btn" plain size="small" @click="exportData">
                            <span class="btn_txt">导出数据</span>
                            <span class="btn_icon">
                                <img :src="require('@/assets/export.png')" alt="">
                            </span>
                        </el-button> -->
          </div>
        </div>
        <div class="search_result">
          <div class="result_panel">
            <div class="list_group" v-for="(item, index) in resultData" :key="index">
              <div class="list_group_content" @click="showDetail(item)">
                <div class="list_group_head">
                  <div class="group_head_title">
                    <div class="head_title">
                      <strong class="title_text">{{ item.name }}</strong>
                      <div class="title_label" v-if="searchType == '1' && item.isActive == 1">
                        <img :src="require('@/assets/hotspot.png')" />活跃
                      </div>
                    </div>
                    <div class="head_tags">
                      <el-tag size="small" v-for="(tag, t) in item.tags" :key="'ht_' + t">
                        {{ tagValue(tag) }}
                      </el-tag>
                    </div>
                  </div>
                  <div class="group_head_tool" v-if="searchType == '1'">
                    平台评分&nbsp;&nbsp;<span class="head_tags_item">{{
                      item.totalScore == 0 ? '--' : item.totalScore > 100 ? 100 : item.totalScore
                    }}</span>
                  </div>
                </div>
                <div class="list_group_body">
                  <div class="group_item" v-for="(list, l) in item.list" :key="l">
                    <div class="group_item_filed">{{ list.label }}:</div>
                    <div class="group_item_value" v-if="(list.net != undefined)">
                      <span class="item_label">{{ list.label }}</span>
                      <div class="item_tag">{{ list.net }} <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                    <div class="group_item_value" :class="{ 'item_more': showMore }" v-else>
                      {{ list.value }}
                      <!-- <el-button class="def_btn" plain size="small" :icon="showMore?'el-icon-arrow-down':'el-icon-arrow-up'" @click="showMore = !showMore">
                                                <span class="btn_txt">{{showMore?'更多':'收起'}}</span>
                                            </el-button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result_pages">
          <div class="page_nav" v-if="currPage * limit < totalCount" @click="getNext"><i class="el-icon-d-arrow-right"
              style="transform: rotate(90deg);"></i>&nbsp;加载更多数据</div>
          <div class="page_nav" v-else><i class="el-icon-d-arrow-right" style="transform: rotate(-90deg);"></i>&nbsp;没有更多了
          </div>
        </div>
      </div>
    </div>
    <div class="to_pageTop" v-show="backTopBar" @click="toPageTop">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>

<script>
import PageTabs from './components/page_tabs.vue'
import SearchInput from './components/search_input.vue';
import SearchFilter from './components/search_filter.vue';
import {
  typeFilter,
  getMedmiddleInfo,
  getTerminalInfo,
  getChannelInfo,
  setBaseInfo,
  changeNum
} from '@/api/portrait.js'
export default {
  name: 'salesmanList',
  components: {
    PageTabs,
    SearchInput,
    SearchFilter
  },
  data() {
    return {
      open: true,
      toolFold: true, //筛选折叠
      sortUp: false,
      totalCount: 0,
      currPage: 1,
      limit: 10,
      searchType: '',
      searchParam: {},
      resultData: [],
      showMore: false,
      toDetail: false,
      scrollTop: 0,
      backTopBar: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('salesmanDetail') == -1 || sessionStorage.getItem('showBack') != 'true') {
      sessionStorage.removeItem('ownDatas')
      sessionStorage.removeItem('childDatas')
    }
    next()
  },
  // 存储数据 返回此页面时为data赋值
  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf('salesmanDetail') > -1) {
      sessionStorage.setItem('refresh', false)
      let scrollH = this.$refs.scroll_content.scrollTop
      sessionStorage.setItem('ownScroll', scrollH)
      sessionStorage.setItem('ownDatas', JSON.stringify(this.$data))
      let childRefs = this.$refs
      let childDatas = {}
      for (var ref in childRefs) {
        childDatas[ref] = childRefs[ref].$data
      }
      sessionStorage.setItem('childDatas', JSON.stringify(childDatas))
    } else {
      sessionStorage.setItem('refresh', true)
      sessionStorage.removeItem('ownDatas')
      sessionStorage.removeItem('childDatas')
      sessionStorage.removeItem('ownScroll')
      this.scrollTop = 0
    }
    next()
  },
  computed: {
    totalNumber() {
      return changeNum(this.totalCount)
    }
  },
  created() {
    if (sessionStorage.getItem('ownDatas')) {
      let datas = JSON.parse(sessionStorage.getItem('ownDatas'))
      Object.assign(this.$data, datas);
      this.scrollTop = sessionStorage.getItem('ownScroll')
      this.positScroll()
    }
  },
  // 监听函数方法
  mounted() {
    this.$refs.scroll_content.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy(){
    this.$refs.scroll_content.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // 滚动函数事件
    handleScroll() {
      let scrollConH = this.$refs.scroll_content.offsetHeight
      let scrollTop = this.$refs.scroll_content.scrollTop;
      //判断滚动区域位置是否大于固定元素初始滚动位置
      if (scrollTop > scrollConH / 2) {
        this.backTopBar = true;
      } else {
        this.backTopBar = false;
      }
    },
    positScroll() {
      this.$nextTick(() => {
        let scrollDom = this.$refs.scroll_content
        if (scrollDom) {
          scrollDom.scrollTo({ top: this.scrollTop, behavior: 'smooth' });
        }
      })
    },
    toPageTop(){
      this.scrollTop = 0;
      this.positScroll();
    },
    // 切换页面
    changeRoute(flag) {
      this.open = flag
      let path = '', queryInfo = this.$route.query
      if (flag) {
        path = '/portrait/salesmanList'
      } else {
        path = '/portrait/BMapHome'
      }
      // 跳转
      this.$router.push({ path: path, query: queryInfo })
    },
    tagValue(row) {
      return typeFilter(row)
    },
    changeFold() {
      //搜索筛选折叠展开
      this.toolFold = !this.toolFold;
    },
    exportData() {// 导出数据

    },
    // 设置查询参数
    setParam(param, toSearch, type) {
      this.searchParam = param == null ? { keyword: this.searchParam.keyword } : { ...this.searchParam, ...param }
      if (type) {
        this.searchType = type
        if (param == null) {
          this.$nextTick(() => {
            this.$refs.search_filter.changeType()
          })
        }
      }

      if (toSearch) {
        this.sortUp = this.searchType == '3' ? true : false
        this.getSearch()
      }
      this.scrollTop = 0;
      this.positScroll();
    },
    getNext() {// 加载更多
      this.currPage++;
      this.searchParam.pageIndex = this.currPage
      this.getSearch(false)
    },
    getSearch(init) {// 获取搜索结果
      let isInit = init === undefined ? true : init
      this.searchParam.sortType = this.sortUp ? 2 : 1
      let params = JSON.parse(JSON.stringify(this.searchParam))
      params.pageSize = this.limit
      if (isInit) {
        params.pageIndex = 1;
        this.currPage = 1;
      }
      let method = null
      if (this.searchType == '1') {
        // 经纪人列表
        method = getMedmiddleInfo(params)
      } else if (this.searchType == '2') {
        // 终端列表
        method = getTerminalInfo(params)
      } else if (this.searchType == '3') {
        // 渠道列表
        method = getChannelInfo(params)
      }
      method.then(res => {
        let data = res.data.records ? res.data.records : []
        this.totalCount = res.data.totalRows
        data = data.map(item => {
          return item = setBaseInfo(item, this.searchType)
        })

        if (isInit) {
          this.resultData = data
        } else {
          let list = [...this.resultData, ...data]
          this.resultData = list
        }
      })
    },
    showDetail(row) {
      let queryInfo = this.$route.query
      if (row) {
        queryInfo.type = this.searchType
        queryInfo.data = JSON.stringify([row])
      }
      queryInfo.from = 'list'
      this.$router.push({ path: '/portrait/salesmanDetail', query: queryInfo })
      sessionStorage.setItem('showBack', 'true')
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/style/portrait.less";

.group_item_value {
  display: flex;

  .item_label {
    color: #4FA1A4;
    margin-right: 15px;
  }

  .item_tag {
    color: #FF991C;
    cursor: pointer;
  }
}
</style>
